import {SelectFilterProvider} from '@github-ui/filter-core/providers'
import {BellIcon} from '@primer/octicons-react'
import {singleValueFilterTypes} from '@github-ui/repos-rules-types/shared-filter-types'
import {DEFAULT_FILTER_PRIORITY} from '@github-ui/filter-core'

export class TimeoutsFilterProvider extends SelectFilterProvider {
  constructor() {
    super(
      {
        displayName: 'Timeout status',
        key: 'timeouts',
        priority: DEFAULT_FILTER_PRIORITY,
        icon: BellIcon,
        description: 'Timeout status: exclude | include | only',
      },
      [
        {value: 'include', displayName: 'Include timeouts', priority: 1},
        {value: 'exclude', displayName: 'Exclude timeouts', priority: 2},
        {value: 'only', displayName: 'Only timeouts', priority: 3},
      ],
      {
        filterTypes: singleValueFilterTypes,
      },
    )
  }
}
